import React, { useState, useEffect } from "react";
import { image } from "../../common/Theme";
import { RadioButton } from "../../component/Radio";
import FlagDropdown from "../../component/FlagDropdown";
import { guestFields, customerLoginFields, loginFields } from "./utils";
import Validation from "../Validation/validation";
import { showError } from "../Validation";
import { useDispatch } from "react-redux";
import { logout, setUser } from "./userSlice";
import { useNavigate, NavLink } from "react-router-dom";
import { loginWithCredential } from "./api";
import Apiconnection from "../../utils/Apiconnection";
import { ToastContainer, toast } from "react-toastify";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Visibility from "@mui/icons-material/Visibility";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { Modal, Button, CircularProgress } from "@mui/material";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ShieldOutlinedIcon from '@mui/icons-material/ShieldOutlined';
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import DirectionsCarOutlinedIcon from '@mui/icons-material/DirectionsCarOutlined';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import SmartphoneIcon from '@mui/icons-material/Smartphone';
import HeadsetMicOutlinedIcon from '@mui/icons-material/HeadsetMicOutlined';
import PhoneOutlinedIcon from '@mui/icons-material/PhoneOutlined';
import GoogleIcon from '@mui/icons-material/Google';

const FeatureIcon = ({ icon, bgColor, title, desc, hasBorder }) => (
  <div style={{ flex: 1, padding: '0 10px', borderRight: hasBorder ? '1px solid #e2e8f0' : 'none', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
    <div style={{ width: '56px', height: '56px', borderRadius: '50%', backgroundColor: bgColor, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px auto' }}>
      {icon}
    </div>
    <h4 style={{ fontSize: '15px', fontWeight: '800', color: '#0f172a', marginBottom: '6px', textAlign: 'center' }}>{title}</h4>
    <p style={{ fontSize: '13px', color: '#64748b', lineHeight: '1.5', textAlign: 'center', maxWidth: '140px' }}>{desc}</p>
  </div>
);

const Login = () => {
  const [data, setData] = useState({
    fName: "",
    lName: "",
    email: "",
    phone: "",
    dialcode: "+1",
  });
  const [isPhoneFocused, setIsPhoneFocused] = useState(false);
  const [focusedField, setFocusedField] = useState("");
  const [data1, setData1] = useState({ username: "", password: "" });
  const [error, setError] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [selectedOption, setSelectedOption] = useState("option1");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isCustomerExists, setIsCustomerExists] = useState(false);
  const [custId, setcustId] = useState("");
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    try {
      const sessionMsg = sessionStorage.getItem("auth_session_message");
      if (sessionMsg) {
        toast.error(sessionMsg, { toastId: 'auth-session-error-toast' });
        sessionStorage.removeItem("auth_session_message");
      }
    } catch (e) {
      // Ignore storage errors
    }
  }, []);

  console.log(data);

  const handleRadioChange = (option) => {
    setSelectedOption(option);
  };

  const handleTogglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData((prev) => ({ ...prev, [name]: value }));
    if (error[name]) {
      setError((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const handleChange1 = (e) => {
    const { name, value } = e.target;
    setData1((prev) => ({ ...prev, [name]: value }));
    if (error[name]) {
      setError((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const handleCustomerSubmit = async () => {
    try {
      const isError = Validation(data1, customerLoginFields);

      if (Object.keys(isError).length > 0) return setError(isError);
      setLoading(true);

      const payload = {
        email: data1?.username,
        dialcode: data?.dialcode,
        password: data1?.password,
        deviceType: 2,
        platform: "CustomerPanel",
      };

      console.log("HEllo ");

      const response = await Apiconnection.post("login", payload);
      const token = response?.data?.data?.user?.webLogin;
      localStorage.setItem("prime_access_token", token);
      localStorage.setItem(
        "userInfo",
        JSON.stringify(response?.data?.data?.user),
      );

      dispatch(setUser(response?.data?.data?.user));

      toast.success(response.data.message);

      const userData = response.data.data.user;
      const { firstName, lastName, phone } = userData;

      navigate("/booking-list", {
        state: {
          email: userData?.email,
          password: data.phone,
          customerId: userData.id,
          firstName: firstName,
          lastName: lastName,
          phone: phone != null ? String(phone).trim() : "",
          payload,
        },
      });
      window.location.reload();
    } catch (error) {
      toast.error(error.response?.data?.message);
      console.log("error", error);
    } finally {
      setLoading(false);
    }
  };

  const checkCustomerExistence = async (phone) => {
    try {
      const payload = {
        customerMobile: phone,
      };
      const response = await Apiconnection.post(
        "customer-exist-check",
        payload,
      );
      if (response?.data?.data?.id) {
        setcustId(response.data.data.id);
      }
      return response.data; // Return the entire response data
    } catch (error) {
      console.error("Error checking customer existence:", error);
      toast.error("Error checking customer existence.");
      return false; // Assume customer does not exist on error
    }
  };

  const handleGuestSubmit = async () => {
    try {
      const isError = Validation(data, guestFields);

      if (Object.keys(isError).length > 0) return setError(isError);
      setLoading(true);
      const customerResponse = await checkCustomerExistence(data.phone);

      if (selectedOption === "option1" && customerResponse.status) {
        setIsCustomerExists(true); // Open the modal if customer exists
        setLoading(false);
      } else {
        const trimmedFName = data?.fName?.trim() || "";
        const trimmedLName = data?.lName?.trim() || "";
        const fullName = `${trimmedFName} ${trimmedLName}`.trim();

        const payload = {
          firstname: trimmedFName,
          lastname: trimmedLName,
          firstName: trimmedFName,
          lastName: trimmedLName,
          name: fullName,
          customer: fullName,
          customerName: fullName,
          email: data?.email?.trim(),
          dialcode: data?.dialcode,
          password: data?.phone,
          phone: data?.phone,
        };

        localStorage.setItem("Booking_as", "guest");

        navigate("/booking-create", { state: { payload } });
        console.log(payload);
        setLoading(false);
      }
    } catch (error) {
      console.log("error", error);
      setLoading(false);
    }
  };

  const handleContinueAsExistingCustomer = () => {
    setIsCustomerExists(false);
    const trimmedFName = data?.fName?.trim() || "";
    const trimmedLName = data?.lName?.trim() || "";
    const fullName = `${trimmedFName} ${trimmedLName}`.trim();

    // Create the payload to pass to the booking-create
    const payload = {
      customerId: custId,
      firstname: trimmedFName,
      lastname: trimmedLName,
      firstName: trimmedFName,
      lastName: trimmedLName,
      name: fullName,
      customer: custId ? String(custId) : fullName,
      customerName: fullName,
      email: data?.email?.trim(),
      dialcode: data?.dialcode,
      password: data?.phone,
      phone: data?.phone,
    };

    navigate("/booking-create", { state: { payload } });
  };

  const handleCloseModal = () => {
    setIsCustomerExists(false);
    // setSelectedOption('option2');
  };

  const handleRegistration = () => {
    navigate("/customer-registration");
  };

  const handleSubmit = () => {
    if (selectedOption === "option2") {
      handleCustomerSubmit();
    } else {
      handleGuestSubmit();
    }
  };

  const handleLogout = () => {
    dispatch(logout());
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', fontFamily: "'Inter', 'Poppins', sans-serif", backgroundColor: '#f0f4f8' }}>
      <style>
        {`
          @keyframes rotate-border {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
          .animated-border-wrapper {
            position: relative;
            padding: 3px;
            border-radius: 26px;
            overflow: hidden;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #fff;
            box-shadow: 0 20px 50px rgba(0,0,0,0.1);
          }
          @media (max-width: 576px) {
            .animated-border-wrapper {
              border-radius: 16px;
            }
          }
          .animated-border-wrapper::before {
            content: '';
            position: absolute;
            width: 150%;
            height: 150%;
            background: conic-gradient(
              from 0deg,
              transparent 0%,
              transparent 40%,
              #004777 50%,
              #22c55e 60%,
              transparent 70%,
              transparent 100%
            );
            animation: rotate-border 12s linear infinite;
            z-index: 0;
          }
          .login-card-inner {
            position: relative;
            z-index: 1;
            background: #fff;
            border-radius: 24px;
            width: 100%;
            overflow: hidden;
          }
          @media (max-width: 576px) {
            .login-card-inner {
              border-radius: 14px;
            }
          }
          .login-page-container {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 20px;
          }
          @media (max-width: 576px) {
            .login-page-container {
              padding: 10px;
            }
          }
          .login-left-panel {
            width: 100%;
            padding: 40px 75px;
            display: flex;
            flex-direction: column;
            min-height: 100%;
            box-sizing: border-box;
          }
          @media (max-width: 1200px) {
            .login-left-panel {
              padding: 40px 50px;
            }
          }
          @media (max-width: 991px) {
            .login-left-panel {
              padding: 40px 40px;
            }
          }
          @media (max-width: 576px) {
            .login-left-panel {
              padding: 30px 20px;
            }
          }
          .login-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 40px;
            gap: 15px;
          }
          @media (max-width: 400px) {
            .login-header {
              flex-direction: column;
              align-items: flex-start;
              gap: 15px;
              margin-bottom: 25px;
            }
          }
          .login-options-container {
            display: flex;
            gap: 15px;
            margin-bottom: 30px;
          }
          @media (max-width: 576px) {
            .login-options-container {
              flex-direction: column;
              gap: 10px;
            }
          }
          .login-trust-badges {
            display: flex;
            justify-content: space-between;
            margin-top: 40px;
            padding-top: 30px;
            border-top: 1px solid #eee;
            gap: 15px;
          }
          @media (max-width: 768px) {
            .login-trust-badges {
              flex-wrap: wrap;
              gap: 20px 15px;
            }
            .login-trust-badges > div {
              flex: 1 1 200px;
            }
          }
          @media (max-width: 480px) {
            .login-trust-badges {
              flex-direction: column;
              gap: 15px;
            }
            .login-trust-badges > div {
              flex: initial;
            }
          }
          .login-footer {
            background-color: #0a192f;
            color: #fff;
            min-height: 60px;
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 30px;
            font-size: 14px;
            font-weight: 500;
            padding: 10px 20px;
            box-sizing: border-box;
          }
          .login-footer-separator {
            width: 1px;
            height: 20px;
            background-color: #334155;
          }
          @media (max-width: 768px) {
            .login-footer {
              flex-direction: column;
              gap: 12px;
              padding: 20px;
              text-align: center;
            }
            .login-footer-separator {
              display: none;
            }
          }
        `}
      </style>
      <div className="container-fluid login-page-container">
        <div className="animated-border-wrapper" style={{ maxWidth: '1440px', width: '100%' }}>
          <div className="row w-100 login-card-inner" style={{ margin: '0' }}>
          {/* Left Side */}
          <div className="col-lg-6 col-12 p-0" style={{ display: 'flex' }}>
            <div className="login-left-panel">
          
          <div className="login-header">
            <div>
              <img src={image.logo} alt="Prime Park Logo" style={{ width: '140px' }} />
            </div>
            <div onClick={() => navigate('/')} style={{ color: '#004777', fontWeight: '600', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '5px', fontSize: '14px' }}>
              <ArrowBackIcon fontSize="small" /> Back to Home
            </div>
          </div>

          <div style={{ flex: 1 }}>
            <h2 style={{ fontSize: '28px', fontWeight: '800', color: '#1a1a1a', marginBottom: '8px' }}>Welcome to Prime Park</h2>
            <p style={{ color: '#666', fontSize: '15px', marginBottom: '30px' }}>Book parking in seconds or manage your reservations</p>

            <div className="login-options-container">
              <div 
                onClick={() => setSelectedOption('option1')}
                style={{ 
                  flex: 1, 
                  padding: '15px', 
                  border: selectedOption === 'option1' ? '2px solid #00a859' : '1px solid #e0e0e0',
                  borderRadius: '12px',
                  backgroundColor: selectedOption === 'option1' ? '#f0fbf4' : '#fff',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '12px',
                  transition: 'all 0.3s'
                }}>
                <div style={{ backgroundColor: selectedOption === 'option1' ? '#e6f6eb' : '#f5f5f5', borderRadius: '50%', padding: '8px', color: selectedOption === 'option1' ? '#00a859' : '#666', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <PersonOutlineIcon fontSize="small" />
                </div>
                <div>
                  <div style={{ fontWeight: '700', color: selectedOption === 'option1' ? '#00a859' : '#333', fontSize: '15px' }}>Continue as Guest</div>
                  <div style={{ fontSize: '12px', color: '#666' }}>Quick booking, no account needed</div>
                </div>
              </div>
              
              <div 
                onClick={() => setSelectedOption('option2')}
                style={{ 
                  flex: 1, 
                  padding: '15px', 
                  border: selectedOption === 'option2' ? '2px solid #004777' : '1px solid #e0e0e0',
                  borderRadius: '12px',
                  backgroundColor: selectedOption === 'option2' ? '#f0f7ff' : '#fff',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '12px',
                  transition: 'all 0.3s'
                }}>
                <div style={{ backgroundColor: selectedOption === 'option2' ? '#e5eff5' : '#f5f5f5', borderRadius: '50%', padding: '8px', color: selectedOption === 'option2' ? '#004777' : '#666', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <PersonOutlineIcon fontSize="small" />
                </div>
                <div>
                  <div style={{ fontWeight: '700', color: selectedOption === 'option2' ? '#004777' : '#333', fontSize: '15px' }}>Sign In</div>
                  <div style={{ fontSize: '12px', color: '#666' }}>Access your account</div>
                </div>
              </div>
            </div>

            {selectedOption === 'option1' && (
              <div className="login-form-sec">
                <div style={{ marginBottom: '15px', color: '#666', fontSize: '14px', display: 'flex', alignItems: 'center' }}>
                  Just a few details to get started
                  <span style={{ fontSize: '20px', marginLeft: '5px', transform: 'rotate(90deg)' }}>⤵</span>
                </div>

                <div className="row g-3" style={{ marginBottom: '20px' }}>
                  <div className="col-sm-6 col-12">
                    <div style={{ position: 'relative' }}>
                      <div style={{ display: 'flex', alignItems: 'center', border: error.fName ? '2px solid #ff4d4f' : '1px solid #e0e0e0', borderRadius: '12px', padding: '0 15px', height: '56px', backgroundColor: '#fff' }}>
                        <PersonOutlineIcon style={{ color: '#999', marginRight: '10px' }} />
                        <input 
                          type="text" 
                          name="fName"
                          placeholder="First Name *" 
                          value={data.fName}
                          onChange={handleChange}
                          style={{ border: 'none', outline: 'none', width: '100%', fontSize: '15px', backgroundColor: 'transparent' }} 
                        />
                      </div>
                      {showError(error?.fName)}
                    </div>
                  </div>
                  <div className="col-sm-6 col-12">
                    <div style={{ position: 'relative' }}>
                      <div style={{ display: 'flex', alignItems: 'center', border: error.lName ? '2px solid #ff4d4f' : '1px solid #e0e0e0', borderRadius: '12px', padding: '0 15px', height: '56px', backgroundColor: '#fff' }}>
                        <PersonOutlineIcon style={{ color: '#999', marginRight: '10px' }} />
                        <input 
                          type="text" 
                          name="lName"
                          placeholder="Last Name *" 
                          value={data.lName}
                          onChange={handleChange}
                          style={{ border: 'none', outline: 'none', width: '100%', fontSize: '15px', backgroundColor: 'transparent' }} 
                        />
                      </div>
                      {showError(error?.lName)}
                    </div>
                  </div>
                </div>

                <div style={{ position: 'relative', marginBottom: '20px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', border: error.email ? '2px solid #ff4d4f' : '1px solid #e0e0e0', borderRadius: '12px', padding: '0 15px', height: '56px', backgroundColor: '#fff' }}>
                    <MailOutlineIcon style={{ color: '#999', marginRight: '10px' }} />
                    <input 
                      type="email" 
                      name="email"
                      placeholder="Email Address *" 
                      value={data.email}
                      onChange={handleChange}
                      style={{ border: 'none', outline: 'none', width: '100%', fontSize: '15px', backgroundColor: 'transparent' }} 
                    />
                  </div>
                  {/* <div style={{ fontSize: '12px', color: '#004777', marginTop: '8px', fontWeight: '500', marginLeft: '5px' }}>We'll send booking details to this email</div> */}
                  {showError(error?.email)}
                </div>

                <div style={{ position: 'relative', marginBottom: '30px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', border: error.phone ? '2px solid #ff4d4f' : '1px solid #e0e0e0', borderRadius: '12px', padding: '0 15px', height: '56px', backgroundColor: '#fff' }}>
                    <PhoneOutlinedIcon style={{ color: '#999', marginRight: '10px' }} />
                    <div style={{ borderRight: '1px solid #eee', paddingRight: '10px', marginRight: '10px', display: 'flex', alignItems: 'center' }}>
                      <FlagDropdown onSelect={(code) => setData((prev) => ({ ...prev, dialcode: code }))} />
                    </div>
                    <input 
                      type="text" 
                      name="phone"
                      placeholder="Mobile Number *" 
                      value={data.phone}
                      onChange={handleChange}
                      maxLength={15}
                      style={{ border: 'none', outline: 'none', width: '100%', fontSize: '15px', backgroundColor: 'transparent' }} 
                    />
                  </div>
                  {/* <div style={{ fontSize: '12px', color: '#004777', marginTop: '8px', fontWeight: '500', marginLeft: '5px' }}>We'll send OTP to verify your number</div> */}
                  {showError(error?.phone)}
                </div>

                <button 
                  onClick={handleSubmit}
                  disabled={loading}
                  style={{ width: '100%', height: '56px', backgroundColor: '#004777', color: '#fff', border: 'none', borderRadius: '100px', fontSize: '16px', fontWeight: '700', cursor: 'pointer', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px' }}>
                  {loading ? <CircularProgress size={24} sx={{ color: '#fff' }} /> : <>Continue as Guest <ArrowForwardIcon fontSize="small" /></>}
                </button>


                <div style={{ textAlign: 'center', fontSize: '15px', color: '#666', marginTop: '25px' }}>
                  Already have an account? <span onClick={() => setSelectedOption('option2')} style={{ color: '#004777', fontWeight: '700', cursor: 'pointer' }}>Sign In</span>
                </div>
              </div>
            )}

            {selectedOption === 'option2' && (
              <div className="login-form-sec">
                <div style={{ marginBottom: '20px', color: '#666', fontSize: '14px', display: 'flex', alignItems: 'center' }}>
                  Enter your details to access your account
                </div>

                <div style={{ position: 'relative', marginBottom: '25px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', border: error.username ? '2px solid #ff4d4f' : '1px solid #e0e0e0', borderRadius: '12px', padding: '0 15px', height: '56px', backgroundColor: '#fff' }}>
                    <MailOutlineIcon style={{ color: '#999', marginRight: '10px' }} />
                    <input 
                      type="email" 
                      name="username"
                      placeholder="Email Address" 
                      onChange={handleChange1}
                      style={{ border: 'none', outline: 'none', width: '100%', fontSize: '15px', backgroundColor: 'transparent' }} 
                    />
                  </div>
                  {showError(error?.username)}
                </div>

                <div style={{ position: 'relative', marginBottom: '30px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', border: error.password ? '2px solid #ff4d4f' : '1px solid #e0e0e0', borderRadius: '12px', padding: '0 15px', height: '56px', backgroundColor: '#fff' }}>
                    <LockOutlinedIcon style={{ color: '#999', marginRight: '10px' }} />
                    <input 
                      type={showPassword ? "text" : "password"} 
                      name="password"
                      placeholder="Password" 
                      onChange={handleChange1}
                      style={{ border: 'none', outline: 'none', width: '100%', fontSize: '15px', backgroundColor: 'transparent' }} 
                    />
                    <span style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }} onClick={handleTogglePasswordVisibility}>
                      {showPassword ? <VisibilityOff style={{ color: '#AEAEAE' }} /> : <Visibility style={{ color: '#AEAEAE' }} />}
                    </span>
                  </div>
                  {showError(error?.password)}
                </div>

                <button 
                  onClick={handleSubmit}
                  disabled={loading}
                  style={{ width: '100%', height: '56px', backgroundColor: '#004777', color: '#fff', border: 'none', borderRadius: '100px', fontSize: '16px', fontWeight: '700', cursor: 'pointer', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px' }}>
                  {loading ? <CircularProgress size={24} sx={{ color: '#fff' }} /> : <>Sign In <ArrowForwardIcon fontSize="small" /></>}
                </button>

                <div style={{ textAlign: 'center', fontSize: '15px', color: '#666', marginTop: '25px' }}>
                  Don't have an account? <span onClick={handleRegistration} style={{ color: '#004777', fontWeight: '700', cursor: 'pointer' }}>Create one</span>
                </div>
              </div>
            )}
          </div>

          <div className="login-trust-badges">
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <div style={{ width: '40px', height: '40px', borderRadius: '50%', backgroundColor: '#e6f6eb', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <ShieldOutlinedIcon style={{ color: '#00a859', fontSize: '20px' }} />
              </div>
              <div>
                <div style={{ fontSize: '12px', fontWeight: '700', color: '#1a1a1a' }}>Secure & Encrypted</div>
                <div style={{ fontSize: '11px', color: '#666' }}>Your data is always safe</div>
              </div>
            </div>

            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <div style={{ width: '40px', height: '40px', borderRadius: '50%', backgroundColor: '#e5eff5', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <PersonOutlineIcon style={{ color: '#004777', fontSize: '20px' }} />
              </div>
              <div>
                <div style={{ fontSize: '12px', fontWeight: '700', color: '#1a1a1a' }}>Trusted by 10,000+ Users</div>
                <div style={{ fontSize: '11px', color: '#666' }}>Across 50+ cities</div>
              </div>
            </div>

            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <div style={{ width: '40px', height: '40px', borderRadius: '50%', backgroundColor: '#efeefd', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <HeadsetMicOutlinedIcon style={{ color: '#6658ea', fontSize: '20px' }} />
              </div>
              <div>
                <div style={{ fontSize: '12px', fontWeight: '700', color: '#1a1a1a' }}>24/7 Customer Support</div>
                <div style={{ fontSize: '11px', color: '#666' }}>We're here to help</div>
              </div>
            </div>
          </div>
            </div>
          </div>

          {/* Right Side */}
          <div className="col-lg-6 d-none d-lg-flex p-0">
            <div style={{ width: '100%', backgroundColor: '#f8fafc', backgroundImage: `url(${image.bodybg})`, backgroundSize: 'cover', backgroundPosition: 'center', padding: '20px', display: 'flex', flexDirection: 'column' }}>
              <div style={{ alignSelf: 'flex-end', display: 'flex', alignItems: 'center', gap: '8px', fontWeight: '700', color: '#0f172a', fontSize: '15px' }}>
            <ShieldOutlinedIcon fontSize="small" style={{ color: '#0f172a' }} /> Secure & Encrypted
          </div>
          
          <div style={{ marginTop: 'auto', marginBottom: 'auto', display: 'flex', flexDirection: 'column' }}>
            <h1 style={{ fontSize: '56px', fontWeight: '900', lineHeight: '1.1', textAlign: 'left', marginBottom: '16px', color: '#0f172a', letterSpacing: '-1px' }}>
              Smart Parking.<br/>
              <span style={{ color: '#22c55e' }}>Hassle Free.</span>
            </h1>
            <p style={{ fontSize: '18px', color: '#475569', maxWidth: '420px', textAlign: 'left', marginBottom: '40px', lineHeight: '1.6', fontWeight: '500' }}>
              Book your spot in advance and enjoy a seamless parking experience.
            </p>
            
            <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '60px' }}>
              <img src={image.car} alt="Cars" style={{ maxWidth: '100%', height: 'auto', objectFit: 'contain' }} />
            </div>
            
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', margin: '0 -10px' }}>
              <FeatureIcon icon={<CalendarTodayOutlinedIcon style={{color: '#22c55e', fontSize: '28px'}}/>} bgColor="#dcfce7" title="Book in Advance" desc="Reserve your spot anytime, anywhere" hasBorder={true} />
              <FeatureIcon icon={<DirectionsCarOutlinedIcon style={{color: '#3b82f6', fontSize: '28px'}}/>} bgColor="#dbeafe" title="Park with Ease" desc="Safe, secure & well-maintained facilities" hasBorder={true} />
              <FeatureIcon icon={<AccessTimeOutlinedIcon style={{color: '#6366f1', fontSize: '28px'}}/>} bgColor="#e0e7ff" title="Save Time" desc="No waiting, no last-minute stress" hasBorder={true} />
              <FeatureIcon icon={<ShieldOutlinedIcon style={{color: '#f59e0b', fontSize: '28px'}}/>} bgColor="#fef3c7" title="Safe & Secure" desc="24/7 surveillance for your peace of mind" hasBorder={false} />
            </div>
            </div>
          </div>
        </div>
      </div>
      </div>
      </div>

      {/* Footer */}
      <div className="login-footer">
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <HeadsetMicOutlinedIcon fontSize="small" /> Need help? We're here for you!
        </div>
        <div className="login-footer-separator"></div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <PhoneOutlinedIcon fontSize="small" /> +1 800-884-0153
        </div>
        <div className="login-footer-separator"></div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <MailOutlineIcon fontSize="small" /> support@primepark.com
        </div>
      </div>

      {/* Modal remains mostly untouched */}
      <Modal open={isCustomerExists} onClose={handleCloseModal} aria-labelledby="customer-exists-modal-title">
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            backgroundColor: "white",
            padding: "40px 30px",
            border: "none",
            borderRadius: "24px",
            width: "90%",
            maxWidth: "450px",
            boxShadow: "0 20px 60px rgba(0, 0, 0, 0.15)",
            textAlign: "center",
          }}
        >
          <h2
            style={{
              fontWeight: "800",
              color: "#1a1a1a",
              marginBottom: "15px",
            }}
          >
            Account Found
          </h2>
          <p
            style={{
              color: "#666",
              fontSize: "16px",
              lineHeight: "1.5",
              marginBottom: "30px",
            }}
          >
            This phone number is already associated with an existing account.
            How would you like to proceed?
          </p>

          <div
            style={{ display: "flex", flexDirection: "column", gap: "12px" }}
          >
            <button
              style={{
                padding: "15px",
                backgroundColor: "#004777",
                color: "white",
                border: "none",
                borderRadius: "100px",
                fontSize: "16px",
                fontWeight: "700",
                cursor: "pointer",
                transition: "all 0.3s",
              }}
              onClick={handleContinueAsExistingCustomer}
            >
              Continue as Guest
            </button>
            <button
              style={{
                padding: "15px",
                backgroundColor: "#f5f5f5",
                color: "#004777",
                border: "none",
                borderRadius: "100px",
                fontSize: "16px",
                fontWeight: "700",
                cursor: "pointer",
                transition: "all 0.3s",
              }}
              onClick={handleCloseModal}
            >
              Login as Customer
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default Login;
